import {
  BOX_COX_OPTIONS as boxCoxOptions,
  LIMIT_METHODS as limitMethods,
  RULES as rules,
  SPEC_LIMITS as specLimits,
  STDEV_METHODS as stdevMethods,
} from "../../../constants/processOptions";
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  TextField,
  MenuItem,
  Switch,
  FormControlLabel,
  Grid,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  FormGroup,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";

const DefinitionPopup = ({
  open,
  onClose,
  definationTabField,
  errors,
  onChange,
  handleSubmit,
  viewData,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [fieldType, setFieldType] = React.useState("defination");

  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  const renderViewTable = () => (
    <Table
      size="small"
      sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
    >
      <TableBody>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", width: "40%", fontSize: "14px" }}>
             Name
          </TableCell>
          <TableCell>{viewData?.step_name}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Description
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Step ID
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Process Step Name
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Review Status
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: 14 }}>
            Sub Products
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Markets
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: 14 }}>
            Target Limit Categories
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Reference URLs
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Attachments
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: "14px" }}>
            Notes
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: 14 }}>
            Batch Data Entry Settings
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600", fontSize: 14 }}>
            Permitted Groups
          </TableCell>
          <TableCell>-</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 0,
          width: isEdit ? 350 : 500,
          maxHeight: "calc(100% - 144px)",
          height: "100%",
          border: "1px solid #ccc",
          p: 1,
          transition: "width 0.3s ease",
          margin: 0,
          boxShadow: "none",
        },
      }}
    >
      <DialogTitle className="dialog-title">
        <Label
          text={isEdit ? "Edit" : "Definition"}
          color="#fff"
          fontSize="14px"
          fontWeight="500"
        />
        <BackButtons size="small" onClick={handleClose} />
      </DialogTitle>

      <DialogContent sx={{ p: 0, mt: 1 }}>
        {isEdit ? (
          <>
            <Box display="flex" mb={1} gap={1}>
              {["Defination", "Analytics", "Alerts"].map((type) => (
                <Buttons
                  key={type}
                  text={type}
                  colors={fieldType === type ? "gray" : "default"}
                  onClick={() => setFieldType(type)}
                />
              ))}
            </Box>
            Edit
          </>
        ) : (
          renderViewTable()
        )}
      </DialogContent>

      {/* <DialogActions
        sx={{ justifyContent: "flex-start", p: 1, borderTop: "1px solid #ccc" }}
      >
        {isEdit ? (
          <>
            <Buttons size="small" text="Submit" onClick={handleSubmit} />
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={() => setIsEdit(false)}
            />
          </>
        ) : (
          <>
            <Buttons
              size="small"
              colors="gray"
              text="Edit"
              onClick={() => setIsEdit(true)}
            />
            <Buttons size="small" colors="gray" text="Change History" />
            <Buttons size="small" colors="orange" text="Delete" />
          </>
        )}
      </DialogActions> */}
    </Dialog>
  );
};

export default DefinitionPopup;
